import Vocabulary, { getVocabulary } from "components/Vocabulary";
import React from "react";
import _ from 'lodash';

const EnvironmentName = ({name, isLowerCase = false, isToolTip = false}) => {
    const envName = _.isObject(name) ? name.name : name
    return ( envName ?
        isToolTip ? 
        <span title={getVocabulary(envName.toLowerCase())}>
            <Vocabulary name={envName.toLowerCase()} isLowerCase={isLowerCase}  />
        </span>
        : <Vocabulary name={envName.toLowerCase()} isLowerCase={isLowerCase}  />
         :
         <>{"N/A"}</>
    )
};

export default EnvironmentName;